import {JsonApiModel, JsonApiModelConfig, Attribute} from "angular2-jsonapi";
/**
 * Created by markush on 3/11/17.
 */

@JsonApiModelConfig({
  type: 'report_category'
})
export class ReportCategory extends JsonApiModel {

  @Attribute()
  name: string;

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/report-category.ts